module.exports = __webpack_public_path__ + "static/text-catchcopy@2x-275f1416dd6fdeaf106cb3a76b1216c7.png";